export default __webpack_public_path__ + "static/media/jornal-iate-nov.764976c3.png";